import React, { Component } from 'react'
import { Button } from 'hljd'
import { SearchBar } from 'hljd'
import { inject, observer } from 'mobx-react'
import LastMonthSelect from '../../LastMonthSelect'
import { getMoney } from '@hlj/hlj-utils'
import moment from 'moment'

const Item = SearchBar.Item

@inject('store')
@observer
export default class extends Component {
  render() {
    const {
      listData: { totalCount, actualMoney },
      exportList
    } = this.props.store
    return (
      <div style={{ marginTop: 20 }}>
        <SearchBar
          store={this.props.store}
          showSearch={false}
          showReset={false}
          extra={<Button onClick={exportList}>导出对账单</Button>}
          initialValues={{
            month: moment().format('YYYY-MM')
          }}
        >
          <Item label="时间" name="month">
            <LastMonthSelect lastToMonth="2018-06" />
          </Item>
        </SearchBar>

        <div style={{ color: '#333', marginBottom: 20 }}>
          <span style={{ marginRight: 40 }}>
            <span>服务费流水笔数：</span>
            <span>{totalCount}</span>
          </span>
          <span>
            <span>实际支付服务费：</span>
            <span>{getMoney(actualMoney)}</span>
          </span>
        </div>
      </div>
    )
  }
}
